export default __webpack_public_path__ + "static/media/location_300.efe6a180.webp";